import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-announce-lined",
  "use": "rt-base-announce-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-announce-lined\"><path d=\"M620.3 118.2L194 344H96c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h98l426.3 225.8c5.3 2.8 11.7-1 11.7-7.1V125.3c0-6-6.4-9.9-11.7-7.1zM194 616h-66V408h66v208z m374 189.7L277 651.6c-10.5-5.5-17-16.4-17-28.3V400.7c0-11.9 6.5-22.7 17-28.3l291-154.1v587.4zM952 480H724.7c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8H952c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM734.3 323.6c3.1 3.1 8.2 3.1 11.3 0l160.7-160.7c3.1-3.1 3.1-8.2 0-11.3l-33.9-33.9c-3.1-3.1-8.2-3.1-11.3 0L700.4 278.4c-3.1 3.1-3.1 8.2 0 11.3l33.9 33.9zM745.6 700.4c-3.1-3.1-8.2-3.1-11.3 0l-33.9 33.9c-3.1 3.1-3.1 8.2 0 11.3l160.7 160.7c3.1 3.1 8.2 3.1 11.3 0l33.9-33.9c3.1-3.1 3.1-8.2 0-11.3L745.6 700.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/announce-lined.svg
// module id = 1630
// module chunks = 228